export default class CommunityStatuses {
    static statuses = [
        {
            label: 'New',
            value: 'New'
        },
        {
            label: 'Active',
            value: 'Active'
        },
        {
            label: 'Open',
            value: 'Open'
        },
        {
            label: 'Closed',
            value: 'Closed'
        }
    ]

    static label(value) {
        return CommunityStatuses.statuses.find(status => status.value === value)?.label;
    }
}
